export default function addedFrequentFlyer(data) {
  return {
    event: 'ffNumberAdded',
    ffProgram: data.ffProgram,
    ffNumber: data.frequentFlyerNumber,
    ffStatus: data.status,
  };
}
